
import {mapState} from 'vuex';
import BlogArticleNav from '~/components/blog/Article/Nav';
import BlogArticleAuthor from '~/components/blog/Article/Author';
import BlogCardHeader from '~/components/blog/Card/Header';
import Constructor from '~/components/catalog/constructor';
import BlogArticleReaction from '~/components/blog/Article/Reaction';
import BlogArticleTags from '~/components/blog/Article/Tags';

export default {
  name: 'BlogArticle',
  components: {
    BlogArticleTags,
    BlogArticleReaction,
    Constructor,
    BlogCardHeader,
    BlogArticleAuthor,
    BlogArticleNav,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isAuthError: false,
      errorTask: null,
    }
  },
  computed: {
    ...mapState('auth', ['hasSession']),
  },
  beforeDestroy() {
    clearTimeout(this.errorTask)
  },
  methods: {
    async onClickReaction(id) {
      if (!this.hasSession) {
        this.isAuthError = true

        clearTimeout(this.errorTask)

        this.errorTask = setTimeout(() => {
          this.isAuthError = false
        },5000)
        return
      }

      try {
        const response = await this.$api.blog.articleReaction(this.article.id, id)

        if (response.message) {
          this.$emit('onReaction', { id, status: response.message })
        }
      } catch (e) {
        console.log(e)
      }
    },
  },

}
